export function Sparkline({ values, height = 24, className = '', title }: { values: number[]; height?: number; className?: string; title?: string }): JSX.Element | null {
  if (!values.length) return null;
  const max = Math.max(1, ...values);
  return (
    <div className={`flex items-end gap-[1px] ${className}`} style={{ height }} title={title}>
      {values.map((v, i) => (
        <div key={i} className={`flex-1 rounded-t-sm ${v > 0 ? 'bg-neon-purple/60' : 'bg-bg-tertiary/60'}`}
          style={{ height: `${v > 0 ? Math.max(8, (v / max) * 100) : 4}%` }} />
      ))}
    </div>
  );
}
